'use client'
import {
  ProductItemSkeleton
} from "./chunk-GQJK47PM.mjs";
import {
  Item_default
} from "./chunk-X26Q276J.mjs";
import {
  CarouselWithLink_default
} from "./chunk-LVDZESI2.mjs";
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";
import {
  useGetDealFilters
} from "./chunk-PTSXFYKW.mjs";
import {
  useExploreQuery
} from "./chunk-LYJH2R5V.mjs";
import {
  useGetProductsList
} from "./chunk-EZ7QK247.mjs";
import {
  useGetExplore
} from "./chunk-HATK644S.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/components/experiences/DealsFeature.tsx
import { Fragment } from "react";
import { jsx } from "react/jsx-runtime";
var DealsFeature = ({ section, detectLoading }) => {
  const { data, isLoading: loading } = useGetExplore(
    {
      entities: ["product"],
      where: {
        deal: { featured: true }
      },
      limit: 10
    },
    {
      enabled: !detectLoading
    }
  );
  const events = (data == null ? void 0 : data.data) || [];
  if (!loading && !(events == null ? void 0 : events.length)) return null;
  return /* @__PURE__ */ jsx(
    DecoratedSection_default,
    {
      section,
      className: "container relative overflow-hidden",
      "data-testid": `section_deals_feature_${section.id}`,
      children: loading && !(events == null ? void 0 : events.length) ? /* @__PURE__ */ jsx("div", { className: "flex gap-4 overflow-hidden", children: [...Array(5)].map((_, i) => /* @__PURE__ */ jsx("div", { className: "shrink-0 basis-56 md:basis-60", children: /* @__PURE__ */ jsx(ProductItemSkeleton, {}) }, i)) }) : /* @__PURE__ */ jsx(
        CarouselWithLink_default,
        {
          section,
          linkClassName: "relative shrink-0 basis-56 md:basis-60 aspect-1",
          children: events.map((event, i) => /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("div", { className: "relative shrink-0 basis-56 md:basis-60 ltr:mr-4 rtl:ml-4", children: /* @__PURE__ */ jsx(
            Item_default,
            {
              item: event,
              cardType: section.itemRenderType,
              section: { id: section.id },
              index: i
            }
          ) }) }, event.id))
        }
      )
    }
  );
};
var DealsFeature_default = DealsFeature;

// src/components/experiences/ExploreDealsGrid.tsx
import { Fragment as Fragment2, useMemo as useMemo2, useState as useState2 } from "react";
import { Button as Button2, Typography as Typography2 } from "@wbk/ui";
import { useTranslation as useTranslation2 } from "@wbk/config";

// src/components/experiences/ExploreDealsFilters.tsx
import { useEffect, useMemo, useState } from "react";
import { useGeolocation, useRouter, useTranslation } from "@wbk/config";
import { useCurrency } from "@wbk/currency";
import { ChevronIcon } from "@wbk/svg";
import {
  Button,
  Carousel,
  DayPicker,
  Menu,
  ResponsiveMenu,
  ResponsivePopover,
  Slider,
  Typography
} from "@wbk/ui";
import { formatDate, formatPrice, splitDateTime } from "@wbk/utils";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var SORT_OPTIONS = [
  { text: "most_popular", value: "" },
  { text: "latest", value: "latest" },
  { text: "oldest", value: "oldest" },
  { text: "price_low_to_high", value: "low_price" },
  { text: "price_high_to_low", value: "high_price" }
];
var ExploreDealsFilters = ({ filters, onChange, total }) => {
  var _a, _b, _c, _d;
  const { locale } = useRouter();
  const { countryCode } = useGeolocation();
  const { t } = useTranslation(["contentful_common"]);
  const { currency } = useCurrency();
  const [selectedDate, setSelectedDate] = useState();
  const [priceRange, setPriceRange] = useState([0, 0]);
  const isPriceFilterApplied = filters.price !== void 0;
  const where = {
    deal_exists: true,
    location: countryCode ? { countryCode } : {}
  };
  const { data, isLoading } = useGetDealFilters({ lang: locale, limit: 50, where });
  const { data: maxPriceData } = useGetProductsList({
    lang: locale,
    limit: 1,
    order: "action_startingPrice_DESC"
  });
  const highestMaxPrice = ((_c = (_b = (_a = maxPriceData == null ? void 0 : maxPriceData.items) == null ? void 0 : _a[0]) == null ? void 0 : _b.action) == null ? void 0 : _c.startingPrice) || 0;
  useEffect(() => {
    if (highestMaxPrice && !isPriceFilterApplied) {
      setPriceRange([0, highestMaxPrice]);
    }
  }, [highestMaxPrice, isPriceFilterApplied]);
  const filtersData = useMemo(() => {
    var _a2, _b2;
    const categories = [];
    const zones = [];
    const tags = [];
    const deals = [];
    for (const collection of ((_a2 = data == null ? void 0 : data.productCollection) == null ? void 0 : _a2.items) || []) {
      if (collection.category && !categories.find((exists) => exists.value === collection.category.slug)) {
        categories.push({ text: collection.category.title, value: collection.category.slug });
      }
      if (collection.zone && !zones.find((exists) => exists.value === collection.zone.slug)) {
        zones.push({ text: collection.zone.title, value: collection.zone.slug });
      }
      if ((_b2 = collection.tagsCollection.items) == null ? void 0 : _b2.length) {
        for (const tag of collection.tagsCollection.items) {
          if (!tags.find((exists) => exists.value === tag.slug)) {
            tags.push({ text: tag.title, value: tag.slug });
          }
        }
      }
      if (collection.deal && !deals.find((exists) => {
        var _a3;
        return exists.value === ((_a3 = collection.deal) == null ? void 0 : _a3.label);
      })) {
        deals.push({ text: collection.deal.label, value: collection.deal.label });
      }
    }
    return {
      categories,
      zones,
      tags,
      deals
    };
  }, [(_d = data == null ? void 0 : data.productCollection) == null ? void 0 : _d.items]);
  const updateFilter = (key, value) => {
    onChange(__spreadProps(__spreadValues({}, filters), { [key]: value }));
  };
  const setArrayFilter = (key, values) => {
    updateFilter(key, values.length ? values : void 0);
  };
  const handleDateRange = () => {
    if ((selectedDate == null ? void 0 : selectedDate.from) && (selectedDate == null ? void 0 : selectedDate.to)) {
      const fromSplitted = splitDateTime(selectedDate.from, "en", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        timeZone: void 0
      });
      const toSplitted = splitDateTime(selectedDate.to, "en", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        timeZone: void 0
      });
      const from = `${fromSplitted.year}-${fromSplitted.month}-${fromSplitted.day}`;
      const to = `${toSplitted.year}-${toSplitted.month}-${toSplitted.day}`;
      updateFilter("date", `${from}_${to}`);
    }
  };
  const handlePriceCommit = () => {
    const [from, to] = priceRange;
    if (from === 0 && to === highestMaxPrice) {
      updateFilter("price", void 0);
    } else {
      updateFilter("price", `${from}_${to}`);
    }
  };
  const dateLabel = useMemo(() => {
    if (!filters.date) return t("contentful_common:date");
    const range = filters.date.split("_");
    const from = range[0];
    const to = range[1];
    if (from && to) {
      return `${formatDate(from, locale, { month: "short", day: "numeric" })} - ${formatDate(to, locale, { month: "short", day: "numeric" })}`;
    }
    return t("contentful_common:date");
  }, [filters.date, locale, t]);
  const priceLabel = useMemo(() => {
    const [from, to] = priceRange;
    if (!isPriceFilterApplied || from === 0 && to === highestMaxPrice)
      return t("contentful_common:price");
    return `${formatPrice(from)} - ${formatPrice(to)} ${currency.shortCode}`;
  }, [priceRange, highestMaxPrice, isPriceFilterApplied, currency.shortCode, t]);
  const categoryLabel = useMemo(() => {
    var _a2;
    if (!((_a2 = filters.category) == null ? void 0 : _a2.length)) return t("contentful_common:category");
    if (filters.category.length === 1) {
      const cat = filtersData.categories.find((c) => {
        var _a3;
        return c.value === ((_a3 = filters.category) == null ? void 0 : _a3[0]);
      });
      return (cat == null ? void 0 : cat.text) || t("contentful_common:category");
    }
    return `${t("contentful_common:category")} (${filters.category.length})`;
  }, [filters.category, filtersData.categories, t]);
  const zoneLabel = useMemo(() => {
    var _a2;
    if (!((_a2 = filters.zone) == null ? void 0 : _a2.length)) return t("contentful_common:zone");
    if (filters.zone.length === 1) {
      const z = filtersData.zones.find((z2) => {
        var _a3;
        return z2.value === ((_a3 = filters.zone) == null ? void 0 : _a3[0]);
      });
      return (z == null ? void 0 : z.text) || t("contentful_common:zone");
    }
    return `${t("contentful_common:zone")} (${filters.zone.length})`;
  }, [filters.zone, filtersData.zones, t]);
  const tagLabel = useMemo(() => {
    var _a2;
    if (!((_a2 = filters.tag) == null ? void 0 : _a2.length)) return t("contentful_common:tags");
    if (filters.tag.length === 1) {
      const tag = filtersData.tags.find((tg) => {
        var _a3;
        return tg.value === ((_a3 = filters.tag) == null ? void 0 : _a3[0]);
      });
      return (tag == null ? void 0 : tag.text) || t("contentful_common:tags");
    }
    return `${t("contentful_common:tags")} (${filters.tag.length})`;
  }, [filters.tag, filtersData.tags, t]);
  const dealLabel = useMemo(() => {
    var _a2;
    if (!((_a2 = filters.deal) == null ? void 0 : _a2.length)) return t("contentful_common:deal_type");
    if (filters.deal.length === 1) {
      const deal = filtersData.deals.find((d) => {
        var _a3;
        return d.value === ((_a3 = filters.deal) == null ? void 0 : _a3[0]);
      });
      return (deal == null ? void 0 : deal.text) || t("contentful_common:deal_type");
    }
    return `${t("contentful_common:deal_type")} (${filters.deal.length})`;
  }, [filters.deal, filtersData.deals, t]);
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between", children: [
    /* @__PURE__ */ jsx2("div", { className: "min-w-0 flex-1", children: /* @__PURE__ */ jsxs(Carousel, { containerClassName: "gap-2 py-1", options: { dragFree: true }, children: [
      /* @__PURE__ */ jsx2("div", { className: "shrink-0", children: /* @__PURE__ */ jsx2(
        ResponsivePopover,
        {
          popover: {
            className: "min-w-96",
            sideOffset: 8,
            align: "start",
            action: {
              onClick: ({ close }) => {
                handleDateRange();
                close();
              }
            }
          },
          sheet: {
            action: {
              onClick: ({ close }) => {
                handleDateRange();
                close();
              }
            }
          },
          render: ({ open }) => /* @__PURE__ */ jsxs(
            Button,
            {
              shape: "outlined",
              theme: "action",
              onClick: open,
              className: "border-action/10 gap-x-XS whitespace-nowrap",
              children: [
                /* @__PURE__ */ jsx2(Typography, { variant: "label-S", children: dateLabel }),
                /* @__PURE__ */ jsx2(ChevronIcon, { className: "h-2 w-2 shrink-0 rotate-90" })
              ]
            }
          ),
          body: () => /* @__PURE__ */ jsxs("div", { className: "space-y-4", children: [
            /* @__PURE__ */ jsx2(Typography, { variant: "heading-S", children: t("contentful_common:select_date") }),
            /* @__PURE__ */ jsx2(
              DayPicker,
              {
                lang: locale,
                mode: "range",
                selected: selectedDate,
                onSelect: (range) => {
                  setSelectedDate(range);
                },
                weekStartsOn: 0,
                startMonth: /* @__PURE__ */ new Date()
              }
            )
          ] })
        }
      ) }),
      filtersData.categories.length > 0 && /* @__PURE__ */ jsx2("div", { className: "shrink-0", children: /* @__PURE__ */ jsx2(
        ResponsiveMenu,
        {
          render: ({ open }) => /* @__PURE__ */ jsxs(
            Button,
            {
              shape: "outlined",
              theme: "action",
              onClick: open,
              disabled: isLoading,
              loading: isLoading,
              className: "border-action/10 gap-x-XS whitespace-nowrap",
              children: [
                /* @__PURE__ */ jsx2(Typography, { variant: "label-S", children: categoryLabel }),
                /* @__PURE__ */ jsx2(ChevronIcon, { className: "h-2 w-2 shrink-0 rotate-90" })
              ]
            }
          ),
          value: filters.category,
          multiple: true,
          onChange: (option) => setArrayFilter("category", option.map((o) => o.value).filter(Boolean)),
          options: filtersData.categories,
          hideErrorSpace: true
        }
      ) }),
      /* @__PURE__ */ jsx2("div", { className: "shrink-0", children: /* @__PURE__ */ jsx2(
        ResponsivePopover,
        {
          popover: {
            className: "min-w-[300px]",
            sideOffset: 8,
            align: "start",
            action: false,
            cancel: false
          },
          sheet: { action: false, cancel: false },
          render: ({ open }) => /* @__PURE__ */ jsxs(
            Button,
            {
              shape: "outlined",
              theme: "action",
              onClick: open,
              className: "border-action/10 gap-x-XS whitespace-nowrap",
              children: [
                /* @__PURE__ */ jsx2(Typography, { variant: "label-S", children: priceLabel }),
                /* @__PURE__ */ jsx2(ChevronIcon, { className: "h-2 w-2 shrink-0 rotate-90" })
              ]
            }
          ),
          body: () => /* @__PURE__ */ jsxs("div", { className: "space-y-6 pb-4", children: [
            /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx2(Typography, { variant: "heading-S", children: t("contentful_common:price_range") }),
              /* @__PURE__ */ jsx2(
                Typography,
                {
                  variant: "body-M",
                  color: "text-secondary",
                  dir: "ltr",
                  className: "rtl:text-end",
                  children: `${formatPrice(priceRange[0])} ${currency.shortCode} - ${formatPrice(priceRange[1])} ${currency.shortCode}`
                }
              )
            ] }),
            /* @__PURE__ */ jsx2(
              Slider,
              {
                className: "[&_[role=slider]]:bg-paper",
                "aria-labelledby": t("contentful_common:price_range"),
                value: priceRange,
                onValueChange: (val) => setPriceRange(val),
                onValueCommit: handlePriceCommit,
                minStepsBetweenThumbs: 1,
                step: 5,
                min: 0,
                max: highestMaxPrice,
                theme: "action"
              }
            )
          ] })
        }
      ) }),
      filtersData.zones.length > 0 && /* @__PURE__ */ jsx2("div", { className: "shrink-0", children: /* @__PURE__ */ jsx2(
        ResponsiveMenu,
        {
          render: ({ open }) => /* @__PURE__ */ jsxs(
            Button,
            {
              shape: "outlined",
              theme: "action",
              onClick: open,
              disabled: isLoading,
              loading: isLoading,
              className: "border-action/10 gap-x-XS whitespace-nowrap",
              children: [
                /* @__PURE__ */ jsx2(Typography, { variant: "label-S", children: zoneLabel }),
                /* @__PURE__ */ jsx2(ChevronIcon, { className: "h-2 w-2 shrink-0 rotate-90" })
              ]
            }
          ),
          value: filters.zone,
          multiple: true,
          onChange: (option) => setArrayFilter("zone", option.map((o) => o.value).filter(Boolean)),
          options: filtersData.zones,
          hideErrorSpace: true
        }
      ) }),
      filtersData.tags.length > 0 && /* @__PURE__ */ jsx2("div", { className: "shrink-0", children: /* @__PURE__ */ jsx2(
        ResponsiveMenu,
        {
          render: ({ open }) => /* @__PURE__ */ jsxs(
            Button,
            {
              shape: "outlined",
              theme: "action",
              onClick: open,
              disabled: isLoading,
              loading: isLoading,
              className: "border-action/10 gap-x-XS whitespace-nowrap",
              children: [
                /* @__PURE__ */ jsx2(Typography, { variant: "label-S", children: tagLabel }),
                /* @__PURE__ */ jsx2(ChevronIcon, { className: "h-2 w-2 shrink-0 rotate-90" })
              ]
            }
          ),
          value: filters.tag,
          multiple: true,
          onChange: (option) => setArrayFilter("tag", option.map((o) => o.value).filter(Boolean)),
          options: filtersData.tags,
          hideErrorSpace: true
        }
      ) }),
      filtersData.deals.length > 0 && /* @__PURE__ */ jsx2("div", { className: "shrink-0", children: /* @__PURE__ */ jsx2(
        ResponsiveMenu,
        {
          render: ({ open }) => /* @__PURE__ */ jsxs(
            Button,
            {
              shape: "outlined",
              theme: "action",
              onClick: open,
              disabled: isLoading,
              loading: isLoading,
              className: "border-action/10 gap-x-XS whitespace-nowrap",
              children: [
                /* @__PURE__ */ jsx2(Typography, { variant: "label-S", children: dealLabel }),
                /* @__PURE__ */ jsx2(ChevronIcon, { className: "h-2 w-2 shrink-0 rotate-90" })
              ]
            }
          ),
          value: filters.deal,
          multiple: true,
          onChange: (option) => setArrayFilter("deal", option.map((o) => o.value).filter(Boolean)),
          options: filtersData.deals,
          hideErrorSpace: true
        }
      ) })
    ] }) }),
    total > 0 && /* @__PURE__ */ jsxs("div", { className: "flex shrink-0 items-center gap-1", children: [
      /* @__PURE__ */ jsx2("p", { children: t("contentful_common:result_and_sort", { total }) }),
      /* @__PURE__ */ jsx2(
        Menu,
        {
          render: ({ open, selected }) => /* @__PURE__ */ jsxs(Button, { theme: "action", shape: "text", className: "p-px", onClick: open, children: [
            /* @__PURE__ */ jsx2(Typography, { variant: "link-M", strong: true, children: selected == null ? void 0 : selected.text }),
            /* @__PURE__ */ jsx2(ChevronIcon, { className: "h-3 w-3 shrink-0 rotate-90" })
          ] }),
          value: filters.sort || "",
          onChange: (option) => updateFilter("sort", option.value || void 0),
          options: SORT_OPTIONS.map((op) => ({
            text: t(`contentful_common:${op.text}`),
            value: op.value
          })),
          hideErrorSpace: true
        }
      )
    ] })
  ] });
};
var ExploreDealsFilters_default = ExploreDealsFilters;

// src/components/experiences/ExploreDealsGrid.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var ExploreDealsGrid = ({ section, detectLoading }) => {
  var _a, _b, _c, _d;
  const { t } = useTranslation2(["contentful_event", "contentful_common"]);
  const [filters, setFilters] = useState2({});
  const params = useMemo2(() => {
    var _a2, _b2, _c2;
    const result = {};
    if (filters.date) result.date = filters.date;
    if ((_a2 = filters.category) == null ? void 0 : _a2.length) result.category = filters.category;
    if (filters.price) result.price = filters.price;
    if ((_b2 = filters.tag) == null ? void 0 : _b2.length) result.tag = filters.tag;
    if ((_c2 = filters.zone) == null ? void 0 : _c2.length) result.zone = filters.zone;
    if (filters.sort) result.sort = filters.sort;
    return result;
  }, [filters]);
  const { query, perPage } = useExploreQuery({ params, perPage: 10 });
  const canFetch = !!query && !detectLoading;
  const { data, fetchNextPage, hasNextPage, isLoading } = useGetExplore(
    __spreadProps(__spreadValues({}, query), {
      limit: perPage,
      entities: ["product"],
      where: __spreadProps(__spreadValues({}, query == null ? void 0 : query.where), {
        deal_exists: true
      })
    }),
    {
      enabled: canFetch
    }
  );
  const events = (data == null ? void 0 : data.data) || [];
  const hasActiveFilters = filters.date || ((_a = filters.category) == null ? void 0 : _a.length) || filters.price || ((_b = filters.tag) == null ? void 0 : _b.length) || ((_c = filters.zone) == null ? void 0 : _c.length) || ((_d = filters.deal) == null ? void 0 : _d.length) || filters.sort;
  if (!isLoading && !(events == null ? void 0 : events.length) && !hasActiveFilters) return null;
  return /* @__PURE__ */ jsxs2(
    DecoratedSection_default,
    {
      section,
      className: "container relative overflow-hidden",
      "data-testid": `section_explore_deals_grid_${section.id}`,
      children: [
        section.title && /* @__PURE__ */ jsxs2("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx3(Typography2, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx3(Typography2, { color: "text-secondary", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx3(ExploreDealsFilters_default, { filters, onChange: setFilters, total: (data == null ? void 0 : data.total) || 0 }),
        /* @__PURE__ */ jsx3("div", { className: "grid grid-cols-2 gap-4 sm:grid-cols-[repeat(auto-fill,minmax(240px,1fr))]", children: isLoading && !events.length ? [...Array(10)].map((_, i) => /* @__PURE__ */ jsx3(ProductItemSkeleton, {}, i)) : events.length ? events.map((event, i) => /* @__PURE__ */ jsx3(Fragment2, { children: /* @__PURE__ */ jsx3(
          Item_default,
          {
            item: event,
            cardType: section.itemRenderType,
            section: { id: section.id },
            index: i
          }
        ) }, event.id)) : /* @__PURE__ */ jsxs2("div", { className: "col-span-full flex w-full flex-col items-center justify-center gap-4 py-12", children: [
          /* @__PURE__ */ jsx3(Typography2, { variant: "label-M", children: t("contentful_event:no_events") }),
          /* @__PURE__ */ jsx3(
            Button2,
            {
              className: "border-action/10 whitespace-nowrap",
              theme: "action",
              shape: "outlined",
              onClick: () => setFilters({}),
              children: t("contentful_event:reset_filters")
            }
          )
        ] }) }),
        hasNextPage && /* @__PURE__ */ jsx3("div", { className: "pt-L flex w-full items-center justify-center", children: /* @__PURE__ */ jsx3(
          Button2,
          {
            theme: "action",
            shape: "outlined",
            className: "border-action/10 whitespace-nowrap",
            onClick: () => fetchNextPage(),
            disabled: isLoading,
            children: t("contentful_common:load_more")
          }
        ) })
      ]
    }
  );
};
var ExploreDealsGrid_default = ExploreDealsGrid;

export {
  DealsFeature_default,
  ExploreDealsGrid_default
};
//# sourceMappingURL=chunk-MY2D2RPG.mjs.map